const discoverTabs = {
	elements: {
		$discoverWhyNowCardsButton: $('.js-discover-why-now-cards-button'),
		$discoverWhyNowCardsText: $('.js-discover-why-now-cards-text'),
	},

	modifiers: {
		activeCard: 'discover-why-now-cards__title--active',
	},

	init() {
		this.initEvents()
	},

	initEvents() {
		this.elements.$discoverWhyNowCardsButton.on('click', this.activeCard.bind(this))
	},

	activeCard(e){
		const $button = $(e.currentTarget)
		const index = $button.data('index')

		if($button.hasClass(this.modifiers.activeCard)) {
			return
		}

		this.elements.$discoverWhyNowCardsButton.removeClass(this.modifiers.activeCard)
		$button.addClass(this.modifiers.activeCard)

		this.elements.$discoverWhyNowCardsText.prop('inert', true)

		this.elements.$discoverWhyNowCardsText.filter(`[data-index="${index}"]`).prop('inert', false)
	},
}

discoverTabs.init()